import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Ability, PureAbility } from "@casl/ability";
import { AblePipe } from '@casl/angular';
import { Pipes } from "./pipes";

@NgModule({
  imports: [CommonModule, AblePipe],

  providers: [
    { provide: Ability, useValue: new Ability() },

    { provide: PureAbility, useExisting: Ability }
  ],
  declarations: [...Pipes],
  exports: [...Pipes]
})
export class AuthorizationModule {}
